import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/material_terms_actions";
import cellGenerator from "./columnUtils";

const material_terms_columns = (isSubaccount) => [
  {
    id: "profile-name",
    Header: "Profile Name",
    accessor: "MaterialTermsFormData.new_profile_material_terms_profile_name",
    Cell: (props) => cellGenerator(props),
    minWidth: 200,
    maxWidth: 250,
  },
  {
    Header: "Section / Item",
    accessor: "MaterialTermsFormData.new_profile_material_terms_section_number",
    Cell: (props) => cellGenerator(props),
    maxWidth: 290,
  },
  // {
  //   Header: "Category",
  //   accessor:
  //     "MaterialTermsFormData.new_profile_material_terms_section_number",
  //   Cell: props => cellGenerator(props)
  // },
  {
    Header: "Summary",
    accessor: "MaterialTermsFormData.new_profile_material_terms_summary",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Details",
    accessor: "MaterialTermsFormData.new_profile_material_terms_details",
    Cell: (props) => cellGenerator(props),
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("material-terms", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default material_terms_columns;
